import React from 'react';
import * as Stars from '@/assets/graphics/stars/stars';
import Typography from '@/components/atoms/typography/typography';
import ShowMore from '@/components/utilities/show-more/show-more';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';
import { capitalizeFirstLetter } from '@/libraries/formatters/capitalize-first-letter';
import styles from './trip-highlights.module.scss';

export interface TripHighlightsProps {
  /** The text to show as headline */
  headline?: string;
  /** The list of highlights to show */
  tripHighlightsItems: {
    description: string;
  }[];
}

const TripHighlights = ({
  headline,
  tripHighlightsItems = [],
}: TripHighlightsProps) => {
  const { brand } = usePageDetailsContext();

  const StarComponent = Stars[`${capitalizeFirstLetter(`${brand}`)}Filled`];

  if (tripHighlightsItems?.length === 0 || tripHighlightsItems === null)
    return null;

  return (
    <div className={styles.component}>
      <Typography className={styles.headline} tag="h2" tagStyle="headingMedium">
        {headline}
      </Typography>

      <ShowMore height={200}>
        <div className={styles.highlights}>
          {tripHighlightsItems.map(({ description }, highlightIndex) => (
            <div key={highlightIndex} className={styles.highlight}>
              <div className={styles.decoration}>
                <StarComponent className={styles.icon} />
              </div>

              <Typography className={styles.text} tagStyle="bodySmall">
                {description}
              </Typography>
            </div>
          ))}
        </div>
      </ShowMore>
    </div>
  );
};

TripHighlights.displayName = 'TripHighlights';

export default TripHighlights;
